import {
  Component,
  inject,
  OnDestroy,
  output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BandwithTestComponent } from '../../../../components/precall/bandwith-test/bandwith-test.component';
import { PingTestComponent } from '../../../../components/precall/ping-test/ping-test.component';
import { PrecallQualityResult } from '../../../../models/app/precall/precall-quality-result';
import { QualityTestService } from '../../../../core/services/quality-test.service';
import { filter, Subscription } from 'rxjs';
import { TaskStateComponent } from '../../../../components/precall/task-state/task-state.component';
import { PingService } from '../../../../core/services/ping.service';
import { BandwidthService } from '../../../../core/services/bandwidth.service';
import { BitrateTestComponent } from '../../../../components/precall/bitrate-test/bitrate-test.component';
import { VideoSessionService } from '../../../../core/services/video-session.service';
import { BitrateInfoTestComponent } from '../../../../components/precall/bitrate-info-test/bitrate-info-test.component';
import { BandwidthInfoTestComponent } from '../../../../components/precall/bandwidth-info-test/bandwidth-info-test.component';
import { MibSpinnerComponent } from '@medinbox/angular';

@Component({
  selector: 'app-precall-quality-step',
  imports: [
    PingTestComponent,
    BandwithTestComponent,
    TaskStateComponent,
    BitrateTestComponent,
    BitrateInfoTestComponent,
    BandwidthInfoTestComponent,
    MibSpinnerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './precall-quality-step.component.html',
})
export class PrecallQualityStepComponent implements OnDestroy {
  qualityService = inject(QualityTestService);
  videoSessionService = inject(VideoSessionService);
  pingService = inject(PingService);
  bandwidthService = inject(BandwidthService);

  result = signal<PrecallQualityResult | undefined>(undefined);
  changed = output<PrecallQualityResult>();
  resultSubscription: Subscription | undefined;

  pingSubscription: Subscription | undefined;
  downloadSubscription: Subscription | undefined;
  uploadSubscription: Subscription | undefined;
  bitrateSubscription: Subscription | undefined;

  ngOnDestroy(): void {
    this.resultSubscription?.unsubscribe();
    this.pingSubscription?.unsubscribe();
    this.downloadSubscription?.unsubscribe();
    this.uploadSubscription?.unsubscribe();
    this.bitrateSubscription?.unsubscribe();
  }

  start() {
    this.pingSubscription = this.pingService.store.data$.subscribe((ping) => {
      const result = this.result();
      if (result) {
        result.ping = ping || undefined;
        this.result.set(result);
        this.changed.emit(result);
      }
    });

    this.downloadSubscription = this.bandwidthService.store.data$
      .pipe(filter((result) => result?.type === 'download'))
      .subscribe((download) => {
        const result = this.result();
        if (result) {
          result.download = download || undefined;
          this.result.set(result);
          this.changed.emit(result);
        }
      });

    this.uploadSubscription = this.bandwidthService.store.data$
      .pipe(filter((result) => result?.type === 'upload'))
      .subscribe((upload) => {
        const result = this.result();
        if (result) {
          result.upload = upload || undefined;
          this.result.set(result);
          this.changed.emit(result);
        }
      });

    this.bitrateSubscription = this.videoSessionService.audioBitRateStore.data$.subscribe(
      (qualityResult) => {
        const result = this.result();
        if (result && qualityResult) {
          result.audioBitrate = qualityResult;
          this.result.set(result);
          this.changed.emit(result);
        }
      },
    );

    this.resultSubscription?.unsubscribe();
    this.resultSubscription = this.qualityService.store.data$.subscribe((result) => {
      this.result.set(result);
      if (result) this.changed.emit(result);
    });

    this.qualityService.run().subscribe((result) => {
      this.result.set(result);
      if (result) this.changed.emit(result);
    });
  }
}
